'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var performUnsubscribe = exports.performUnsubscribe = function performUnsubscribe(channels, channelId) {
  var channel = channels.get(channelId);

  channel.unsubscribe();
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/performUnsubscribe.js
// module id = 783
// module chunks = 2 3